var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmploymentVerificationLetter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Other/logo/colored/Employment Verification Letter") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "26.4434725%",
    y1: "88.008125%",
    x2: "76.1992369%",
    y2: "10.6570508%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#467EC0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B9AD2",
    offset: "49.1568917%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#41C3DE",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/colored/Employment-Verification-Letter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152,24 L152.304956,24.0038001 C158.691265,24.1631303 163.839422,29.3128081 163.996316,35.6997216 L164,36 L164,156 L163.9962,156.304956 C163.83687,162.691265 158.687192,167.839422 152.300278,167.996316 L152,168 L52,168 L51.6031112,167.996785 C38.6618939,167.786968 28.2108776,157.334653 28.0031514,144.392927 L28,144 L28,90 L28.0041411,89.7751201 C28.1197515,86.641227 30.6418105,84.1273349 33.775173,84.011194 L34,84.007 L52,84 L52,36 L52.0038001,35.6950439 C52.1631303,29.3087347 57.3128081,24.1605776 63.6997216,24.0036843 L64,24 L152,24 Z M148,36 L68,36 C65.8579394,36 64.1089293,37.6840992 64.0048957,39.8003715 L64,40 L64,132 L63.9961999,132.304956 C63.8368697,138.691265 58.6871919,143.839422 52.3002784,143.996316 L52,144 L52,96 L40,96 L40,140 L40.0030362,140.314886 C40.1687391,148.900537 47.0961252,155.829175 55.6812828,155.996889 L56,156 L148,156 L148.199628,155.995104 C150.247634,155.894427 151.890899,154.253188 151.994785,152.206027 L152,152 L152,40 L151.995104,39.8003715 C151.894427,37.752366 150.253188,36.1091013 148.206027,36.0052153 L148,36 Z M140,116 C142.209,116 144,117.791 144,120 C144,122.142061 142.315901,123.891071 140.199628,123.995104 L140,124 L76,124 C73.791,124 72,122.209 72,120 C72,117.857939 73.6840992,116.108929 75.8003715,116.004896 L76,116 L140,116 Z M140,100 C142.209,100 144,101.791 144,104 C144,106.142061 142.315901,107.891071 140.199628,107.995104 L140,108 L76,108 C73.791,108 72,106.209 72,104 C72,101.857939 73.6840992,100.108929 75.8003715,100.004896 L76,100 L140,100 Z M140,84 C142.209,84 144,85.791 144,88 C144,90.1420606 142.315901,91.8910707 140.199628,91.9951043 L140,92 L76,92 C73.791,92 72,90.209 72,88 C72,85.8579394 73.6840992,84.1089293 75.8003715,84.0048957 L76,84 L140,84 Z M100,68 C102.209,68 104,69.791 104,72 C104,74.1420606 102.315901,75.8910707 100.199628,75.9951043 L100,76 L76,76 C73.791,76 72,74.209 72,72 C72,69.8579394 73.6840992,68.1089293 75.8003715,68.0048957 L76,68 L100,68 Z",
    id: "Logo",
    fill: "url(#linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmploymentVerificationLetter);
export default __webpack_public_path__ + "36575b2719abbdd8197cf60e3f9f20d0.svg";
export { ForwardRef as ReactComponent };